/**
 * NotFoundPage.tsx
 * ----------------
 * Page wrapper for the 404 not found screen.
 */

import Layout from '../components/common/Layout';
import NotFound from '../components/NotFound';

const NotFoundPage = () => {
  return (
    <Layout>
      <NotFound />
    </Layout>
  );
};

export default NotFoundPage;
